import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { PTA_COMPETENCY_ITEMS } from './ptaConstants';

const PtaCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="PTA"
            title="PTA CLINICAL COMPETENCY ASSESSMENT"
            items={PTA_COMPETENCY_ITEMS}
            totalPages={4}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            targetUserId={targetUserId}
            onClose={onClose}
        />
    );
};

export default PtaCompetency;
